import type { SVGProps } from 'react';
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}>
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeWidth={2}
        d="M7.049 2.927c.3-.922 1.603-.922 1.902 0l.62 1.91a1 1 0 0 0 .952.69h2.008c.969 0 1.372 1.24.588 1.81l-1.625 1.18a1 1 0 0 0-.363 1.118l.62 1.91c.3.922-.755 1.688-1.538 1.118l-1.625-1.18a1 1 0 0 0-1.176 0l-1.625 1.18c-.783.57-1.838-.196-1.538-1.118l.62-1.91a1 1 0 0 0-.363-1.118L2.88 7.337c-.784-.57-.38-1.81.588-1.81h2.008a1 1 0 0 0 .951-.69z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStar;
